import { createContext, useContext } from 'react';

export const AuthContext = createContext<any>(null);
export const AudioPlayerStateContext = createContext<any>(null);
export const AudioPlayerProgressContext = createContext<any>(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    return context;
};

export const useAudioPlayerState = () => {
    const context = useContext(AudioPlayerStateContext);
    return context;
};

export const useAudioPlayerProgress = () => {
    const context = useContext(AudioPlayerProgressContext);
    return context;
};
